import { Link } from 'react-router-dom'
import { usePortalUiLanguage } from '../contexts/PortalUiLanguageContext'
import { adminNavTo } from '../utils/mailAlertHost'
import type { EmployeeWorkspace } from '../utils/employeeWorkspace'

/** The same permission-filtered actions as the classic employee home. */
export default function EmployeeWorkspaceActions({ workspace }: { workspace: EmployeeWorkspace }) {
  const { lang } = usePortalUiLanguage()
  if (!workspace.actions.length) return null
  const title = { ru: 'Быстрый доступ', en: 'Quick access', id: 'Akses cepat' }[lang]
  return (
    <section className="employee-workspace-actions" aria-label={title}>
      <span className="employee-workspace-actions__label">{title}</span>
      <div className="employee-workspace-actions__links">
        {workspace.actions.map((action, index) => {
          const className = `employee-workspace-action${index === 0 ? ' employee-workspace-action--primary' : ''}`
          const content = <>{action.label[lang]}<span aria-hidden="true">↗</span></>
          return action.spa
            ? <Link key={action.id} className={className} to={adminNavTo(action.href)}>{content}</Link>
            : <a key={action.id} className={className} href={adminNavTo(action.href)}>{content}</a>
        })}
      </div>
    </section>
  )
}
